import { FC } from 'react'
import { Page } from '../../../components/Page'
import { NavTabs } from '../../../components/NavTabs'
import { Outlet } from 'react-router-dom'
import { useAuthorizedTabs } from '../../../hooks/useAuthorizedTabs'
import { UnauthorizedPage } from '../../UnauthorizedPage'

export const ErtSearchPage: FC = () => {
  const { tabs, isUnauthorized } = useAuthorizedTabs(
    [
      { label: 'Engagements', to: 'engagement', dataTestId: 'engagement-search-tab' },
      { label: 'Alarms', to: 'alarm', dataTestId: 'alarm-search-tab' }
    ],
    { redirectToFirstTab: true }
  )

  return (
    <Page title="Engagement Review" showLocationSearchBar={false} showChildrenWhenMissingLocation={true}>
      <NavTabs tabs={tabs} />
      {isUnauthorized ? <UnauthorizedPage /> : <Outlet />}
    </Page>
  )
}
